<template>
    <div class="dankal-image-upload">
        <p v-for="(item, index) in list" :key="index">
            <img class="upload_img" :src="communalInfo.BucketDomain + item" alt="" />
            <img class="close" src="@/assets/img/close.png" @click="onDeleted(index)" />
        </p>

        <div class="add-box" v-if="list.length < limit">
            <img @click="onSelected" class="add" src="@/assets/img/add-img.png" alt="" />
            <!-- <span v-if="type == 1">上传图片({{ list.length }}/{{ limit }})</span> -->
            <!-- <span v-if="type == 2">尺寸：695*418像素，图片格式JPG,png</span> -->
        </div>
        <input multiple="multiple" ref="input" type="file" id="file" accept="image/*" style="display:none;" @change="onFileChanged" />
    </div>
</template>

<script>
    import ImageCompressor from 'image-compressor.js';
    import { uploadImg } from '@/api/common';
    import {mapState,mapActions} from "vuex";
export default {
    name: 'imageUpload',
    data() {
        return {
            list: []
        };
    },

    created() {
        this.getCommunal();
    },
    
    computed:{
        ...mapState(["communalInfo"]),
    },

    props: {
        value: {
            type: Array,
            required: true
        },

        limit: {
            type: Number,
            default: 3
        },

        quatity: {
            type: Number,
            default: 0.6
        },

        // 1是帖子上传图片，2是上传封面图，3是上传反馈
        type: {
            type: Number,
            default: 1
        }
    },

    watch: {
        value(n) {
            this.list = n;
        }
    },

    mounted() {
        this.list = this.value;
    },

    methods: {
        ...mapActions(["getCommunal"]),
        onSelected() {
            const { limit, list } = this;
            if (limit && list.length >= limit) {
                this.$message(`只能上传${limit}张图片`);
                return;
            }
            this.$refs.input.click();
        },

        // 删除图片
        onDeleted(index) {
            this.list.splice(index, 1);
            this.$emit('input', this.list);
        },

        onFileChanged(event) {
            // const file = event.target.files[0];
            var fileList = event.target.files;
            var file;
            for (var i = 0; i < fileList.length; i++) {
                file = fileList[i];

                if (!file) return;

                // eslint-disable-next-line
                new ImageCompressor(file, {
                    quatity: this.quatity,
                    // eslint-disable-next-line
                    success: result => {
                        this.upload(result);
                    },
                    // eslint-disable-next-line
                    error: error => {
                       this.$message(error.message);
                    }
                });
            }
        },

        async upload(file) {
            const formData = new FormData();
            formData.append('token', this.communalInfo.token);
            formData.append('file', file);
            const res = await uploadImg(formData).catch(() => {});
            if (res.status === 200) {
                this.list.push(res.data.hash);
                if (this.list.length > this.limit) {
                    this.$message('最多只能上传' + this.limit + '张图片');
                    this.list = this.list.slice(0, this.limit);
                }
                this.$emit('input', this.list);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.dankal-image-upload {
    display: flex;
    flex-wrap: wrap;
    p {
        position: relative;
        width:120px;
        height: 120px;
        margin-right: 10px;
		margin-bottom: 10px;
        float: left;
        .upload_img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: 1px solid #c0ccda;
            border-radius: 6px;
        }
        .close {
            width: 12px;
            height: 12px;
            position: absolute; 
            top: 4px;
            right: 4px;
            @include cursor-style
        }
    }

    p:nth-child(3n) {
        margin-right: 0;
    }
    .add-box {
        display: flex;
        flex-direction: column;
        .add {
            width:120px;
            height: 120px;
            @include cursor-style
        }
        span {
            color: #cfcfcf;
            font-size: 12px;
        }
    }
}
</style>
